export default __webpack_public_path__ + "static/media/林仁俊.990d0754.jpg";